module.exports = __webpack_public_path__ + "img/shade_text.32d708ef.png";